module.exports = __webpack_public_path__ + "img/apple-icon-144x144.97d04fc0.png";